
import React from 'react';
import { CProgress } from '@coreui/react';

const TimeAtDeskWidget = ({ timeAtDesk }) => (
  <div>
    <div className="mb-2">TimeAtDesk</div>
    <strong>{timeAtDesk} (40.15%)</strong>
    <CProgress className="CProgress-xs mt-2" color="primary" value={40} />
  </div>
);

export default TimeAtDeskWidget;


